// extracted by mini-css-extract-plugin
module.exports = {"userPanel":"SupplierPanel_userPanel__1eFhG","deleteButton":"SupplierPanel_deleteButton__yAUps"};